
import { SET_AUTHENTICATED, SET_CURRENT_ROUTE, SET_DEVICE, SET_USER } from "./constants";
import store from "./store";


const actions = {  

   setAuthenticated(authenticated=true) {
      
      const action = {
         type: SET_AUTHENTICATED,
         payload: authenticated,
      };

      store.dispatch(action);
   },

   setCurrentRoute(route) {
      
      const action = {
         type: SET_CURRENT_ROUTE,
         payload: route,
      };

      store.dispatch(action);
   },

   setDeviceInfo(device) {
      
      const action = {
         type: SET_DEVICE,
         payload: device,
      };

      store.dispatch(action);
   },

   setUser(user) {
      
      const action = {
         type: SET_USER,
         payload: user,
      };

      store.dispatch(action);

   }

}

export default actions;